import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {AnimationOptions} from 'ngx-lottie';
import { ConfigService } from './../../services/webFeeder/config.service';
import { Constants } from './../../utils/constants';

@Component({
  selector: 'app-register-completed',
  templateUrl: './register-completed.component.html',
  styleUrls: ['./register-completed.component.scss']
})
export class RegisterCompletedComponent implements OnInit {

  lottieConfig: { path: string; renderer: string; autoplay: boolean; loop: boolean; };
  private desktopDownloadUrl = Constants.LINK_DOWNLOAD_FT_DESKTOP;
  private androidDownloadUrl = Constants.LINK_DOWNLOAD_FT_ANDROID;
  private iosDownloadUrl = Constants.LINK_DOWNLOAD_FT_IOS;
  message: string;
  registerGoToIdentity = this._configService.registerGoToIdentity();
  optionsLottie: AnimationOptions = {
    path: Constants.SENDING_EMAIL_ANIMATION_URL,
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _configService: ConfigService
  ) {
    this.message = !this.registerGoToIdentity ? Constants.ONBOARD_MSG_01 : Constants.ONBOARD_MSG_03;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['personMsg'] === 'true') {
        this.message = Constants.ONBOARD_MSG_02;
      }
    });
  }

  ngOnInit(): void {
    this.lottieConfig = {
      path: Constants.SENDING_EMAIL_ANIMATION_URL,
      renderer: 'canvas',
      autoplay: true,
      loop: true
    };
  }

  openAppStore() {
    window.open(this.iosDownloadUrl, '_blank');
  }

  openGooglePlay() {
    window.open(this.androidDownloadUrl, '_blank');
  }

  downloadDesktop() {
    window.location.href = this.desktopDownloadUrl;
  }

}
